export const level = "Level";
export const aLaCarte   = "A La Carte";

export const sponsorshipTypes = [
    level, 
    aLaCarte
];
